import { render, staticRenderFns } from "./tabComp1.vue?vue&type=template&id=79eb6242&scoped=true&"
import script from "./tabComp1.vue?vue&type=script&lang=js&"
export * from "./tabComp1.vue?vue&type=script&lang=js&"
import style0 from "./tabComp1.vue?vue&type=style&index=0&id=79eb6242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb6242",
  null
  
)

export default component.exports